import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchCodeUrl } from '@/constants/urls';
import { closeRequest } from '../actions';
import RequestActions from '../components/RequestActions';
import RequestPanel from '../components/RequestPanel';

export default (urls, access) => ({
  ...tabTemplate('request', RequestPanel, matchCodeUrl([...urls, 'request']), RequestActions),
  ...tabCloser('closeRequestTab', closeRequest),
  ...tabIcons('key'),
  access,
  componentState: ({ args, url }) => categoryCodeTab(url, args[4]),
  order: 515,
});
